import { render, staticRenderFns } from "./addWorkList.vue?vue&type=template&id=ba541198&scoped=true"
import script from "./addWorkList.vue?vue&type=script&lang=js"
export * from "./addWorkList.vue?vue&type=script&lang=js"
import style0 from "./addWorkList.vue?vue&type=style&index=0&id=ba541198&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba541198",
  null
  
)

export default component.exports